import PropTypes from 'prop-types';

import CardBlogEntryMobile from '@seo-frontend-components/card-blog-entry-mobile';

import { UI_STYLE_PREFIX } from '../../constants/appConstants';

const React = require('react');

const BlogEntryContainerMobileComponent = ({
  blogEntries,
  jsDisabled,
  supportWebP,
}) => {
  const namespace = `${UI_STYLE_PREFIX}-entry-container-mobile`;

  return (
    <div className={`${namespace}`}>
      {blogEntries.map((blog) => (
        <CardBlogEntryMobile
          key={`${blog.title}`}
          blog={blog}
          jsDisabled={jsDisabled}
          supportWebP={supportWebP}
          preload
        />
      ))}
    </div>
  );
};

BlogEntryContainerMobileComponent.propTypes = {
  jsDisabled: PropTypes.bool.isRequired,
  supportWebP: PropTypes.bool.isRequired,
  blogEntries: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }).isRequired,
      description: PropTypes.string.isRequired,
      tags: PropTypes.arrayOf(PropTypes.string),
      tags_metadata: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
};

export default BlogEntryContainerMobileComponent;
